import { render, staticRenderFns } from "./OnlineUsersHeader.vue?vue&type=template&id=ff19a156&scoped=true&lang=pug"
import script from "./OnlineUsersHeader.vue?vue&type=script&lang=js"
export * from "./OnlineUsersHeader.vue?vue&type=script&lang=js"
import style0 from "./OnlineUsersHeader.vue?vue&type=style&index=0&id=ff19a156&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff19a156",
  null
  
)

export default component.exports